<div class="list-container">
    <div class="list-content">
        <div class="list-details">
            <h4 class="list-details-title">Ticket Priority List</h4>
            <table class="table table-striped">
                <thead>
                <tr>
                    <th scope="col">Priority Status</th>
                    <th scope="col">Time In Hrs</th>
                    <th scope="col">Action</th>
                </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let list of ticketPriority;let i = index">
                        <th scope="col">{{list.priorityStatus}}</th>
                        <td scope="col">{{list.timeInHrs}}</td>
                        <td>
                            <i class="bi bi-pencil-square" (click)="getTicketPriorityByStatus(list.priorityStatus)" data-toggle="modal" data-target="#updateModal"></i>
                        </td>
                    </tr>
                </tbody>
            </table>
            <!-- <div class="pagination-block" *ngIf="educationList.length != 0">
                <pagination-controls
                    previousLabel="Prev"
                    nextLabel="Next"
                    (pageChange)="onTableDataChange($event)"
                >
                </pagination-controls>
            </div> -->
        </div>
    </div>
</div>



<div class="modal fade" id="updateModal" tabindex="-1" data-backdrop="static" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteModalLabel">Update
                    <span data-dismiss="modal">
                    <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                    </svg>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <div class="form-group">
                    <label for="">Status</label>
                    <p>{{singleTicketPriority.priorityStatus}}</p>
                </div>
                <div class="form-group">
                    <label for="">Time</label>
                    <input type="number" name="" (keypress)="keyPressNumbers($event)" [(ngModel)]="timeInHrs" class="form-control" id="">
                </div>
                <div class="modal-footer">
                    <button type="button" id="closeModalButton1" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" (click)="updateTicketPriorityTime()">Update</button>
                </div>
            </div>
        </div>
    </div>
</div>